import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { defaultDoc } from '../share/defaultDoc';
import type { PrimaryCauseOfFailure } from './primaryCauseOfFailure.types';

export const primaryCauseOfFailurePullQueryBuilder = (document: PrimaryCauseOfFailure) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query primaryCauseOfFailureFeed($lastRequested: DateTime) {
      primaryCauseOfFailureFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};
